import { useMutation } from "@apollo/client";
import {
  DELETE_TEAM,
  GET_TEAMS,
  TEAMS_WITH_PERMISSION,
  GET_TEAMS_BY_MANAGER_ID,
} from "../../GraphQL/Teams";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteTeamDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteTeam, { loading, error }] = useMutation(DELETE_TEAM, {
    variables: { id: props.team.id },
    refetchQueries: [GET_TEAMS, TEAMS_WITH_PERMISSION, GET_TEAMS_BY_MANAGER_ID],
    onCompleted: () => {
      notifySuccess("Team deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.team.name}
      onConfirm={deleteTeam}
      loading={loading}
      error={error}
      confirmTestId="saveDeleteTeamDialogButton"
      cancelTestId="closeDeleteTeamDialogButton"
    />
  );
};

export default DeleteTeamDialog;
